import {Button} from '@/components/ui/button/Button'
import {Container} from '@/components/ui/container/Container'

import {useTranslation} from 'react-i18next'
import {StyledEmail, StyledFlexContainer} from '../access-denied/style'
import {ArrowLeftIcon, Email01Icon, SlashCircleIcon} from '@/assets/icons/icons'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {StyledTextContainer} from './style'
import {ROUTE_LOGIN} from '@utilities/constants'
import {StyledGoToLoginContainer} from '@/features/password-recovery/components/reset-password/style.ts'
import {useNavigate} from 'react-router-dom'
import useCopyToClipboard from '@/hooks/useCopyToClipboard'
import {toast} from '@/utilities/toast/toast'

export const InactiveReseller = () => {
    const {t} = useTranslation()
    const navigate = useNavigate()

    const {copyToClipboard} = useCopyToClipboard(() => {
        toast.success(t('commons:copied'))
    })

    return (
        <Container fullWidth fullHeight>
            <StyledFlexContainer direction="column" justify="center" align="center" gap={8}>
                <SlashCircleIcon />
                <StyledTextContainer>
                    <h4>{t('inactive_reseller:title')}</h4>
                    <Flexbox direction="column" gap={3} align="center">
                        <p>{t('inactive_reseller:subtitle')}</p>
                        <p>{t('inactive_reseller:subtitle_2')}</p>
                    </Flexbox>
                </StyledTextContainer>
                <Flexbox direction="column" align="center" gap={4}>
                    <Button
                        variant="primary"
                        type="button"
                        onClick={() => window.open('mailto:arya@aryagroupspa.com', '_blank')}
                    >
                        {t('inactive_reseller:cta')}
                        <Email01Icon />
                    </Button>
                    <p>
                        {t('inactive_reseller:copy_email')}{' '}
                        <StyledEmail
                            style={{cursor: 'pointer'}}
                            onClick={() => copyToClipboard('arya@aryagroupspa.com')}
                        >
                            arya@aryagroupspa.com
                        </StyledEmail>
                    </p>
                </Flexbox>
                <StyledGoToLoginContainer justify={'center'} gap={1} onClick={() => navigate(ROUTE_LOGIN)}>
                    <ArrowLeftIcon width={20} height={20} />
                    <p>{t('recovery_password:form:link')}</p>
                </StyledGoToLoginContainer>
            </StyledFlexContainer>
        </Container>
    )
}

InactiveReseller.displayName = 'InactiveReseller'
